import { VARIANT } from '@/src/utils/buildUtils'
import { featureConfig } from '@/src/utils/featureConfig'
import { isCTAE } from '@/src/utils/generalUtils/isCTAE'

export const isSmilesEnabledForBrand = (): boolean => !!featureConfig[VARIANT]?.SMILES && isCTAE()

export default isSmilesEnabledForBrand
